import { render } from "./ChangePasswordPage.vue?vue&type=template&id=1e35a30e&scoped=true"
import script from "./ChangePasswordPage.vue?vue&type=script&lang=js"
export * from "./ChangePasswordPage.vue?vue&type=script&lang=js"

import "./ChangePasswordPage.vue?vue&type=style&index=0&id=1e35a30e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e35a30e"]])

export default __exports__